module.exports = __webpack_public_path__ + "img/telkomsat.41ef848a.webp";